import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Step1 from "./EventMarketingGallery/Step1";
import Step2 from "./EventMarketingGallery/Step2";
import Step3 from "./EventMarketingGallery/Step3";

export default function Gallery() {
  const navigate = useNavigate();
  const location = useLocation();
  const baseState = location.state || {};

  const localStoreId =
    baseState?.id ??
    (localStorage.getItem("local_store_id")
      ? Number(localStorage.getItem("local_store_id"))
      : null);

  const storeBusinessNumber =
    baseState?.store_business_number ||
    localStorage.getItem("store_business_number") ||
    "";

  // 현재 스텝
  const [step, setStep] = useState(1);

  // Step1: 이미지 정보
  const [imageState, setImageState] = useState({
    imageFile: baseState.imageFile || null,
    imagePreview:
      baseState.imageDataUrl || baseState.imagePreview || null,
    imageUri: baseState.imageUri || null,
  });

  // Step2, 3: 옵션 값
  const userMenu = localStorage.getItem("customMenu")
  const [optionState, setOptionState] = useState({
    customMenu: baseState.custom_menu || "",
    category: baseState.category || "",
    age: "",
    channel: "",
    theme: "",
    customText: "",
    style: "",
    bg_prompt: "",
    filter: "",
  });

  // console.log(optionState)

  // Step3에서 사용하는 updateData
  const updateOptionState = (patch) =>
    setOptionState((prev) => ({ ...prev, ...patch }));

  // 최종 이동 (Step3 → 결과 페이지)
  const goResult = () => {
    navigate("/manual/marketing/camera/loading", {
      replace: true,
      state: {
        // 이미지
        imageFile: imageState.imageFile,
        imageUri: imageState.imageUri,
        // Step2 값
        custom_menu: optionState.customMenu,
        category: baseState?.detail_category_name,
        // Step3 값
        age: optionState.age,
        channel: optionState.channel,
        title: optionState.theme,
        customText: optionState.customText,
        style: optionState.style,
        bg_prompt: optionState.bg_prompt,
        filter: optionState.filter,
        // 매장 정보
        store_name: baseState?.store_name,
        road_name: baseState?.road_name,
        district_name: baseState?.district_name,
        main: baseState?.main,
        temp: baseState?.temp,
        data: baseState,

      },
    });
  };

  // 스텝 렌더링
  if (step === 1) {
    return (
      <Step1
        data={baseState}
        image={imageState}
        setImage={setImageState}
        onNext={() => setStep(2)}
        onBack={() => navigate(-1)}
      />
    );
  }

  if (step === 2) {
    return (
      <Step2
        data={optionState}
        userMenu={userMenu}
        localStoreId={localStoreId}
        storeBusinessNumber={storeBusinessNumber}
        updateData={updateOptionState}
        onNext={() => setStep(3)}
        onBack={() => setStep(1)}
      />
    );
  }

  return (
    <Step3
      data={optionState}
      image={imageState}
      updateData={updateOptionState}
      onBack={() => setStep(2)}
      onSubmit={goResult}
    />
  );
}
